import { localStorageHelper } from '../../../../utils';
import FormikField from './FormikField';
import { Divider, Tooltip } from 'antd';
import React from 'react';
import { QuestionCircleOutlined } from '@ant-design/icons';
import {
    canViewThirdPartyCampaignFeatures,
    hasManageSuppliersCampaignsAuthority,
    THIRD_PARTY_CAMPAIGN_OWNERS,
} from '../../promotionUtils';

const ConfigurationTab = ({ formik }: any) => {
    const timezoneList = localStorageHelper
        .getChainedValue('user.timezoneList')
        ?.map((value: any) => ({
            label: `UTC${value.offset} ${value.area}/${value.location}`.toUpperCase(),
            value: value.id,
        }));
    const canManageSuppliersCampaigns =
        canViewThirdPartyCampaignFeatures() && hasManageSuppliersCampaignsAuthority();

    return (
        <div className="space-y-8">
            <div className="flex flex-col space-y-5">
                <div className="flex gap-4 items-start">
                    <FormikField
                        name="campaign_name"
                        category="input"
                        label="Campaign Name"
                        className="w-full max-w-sm"
                    />
                    {canManageSuppliersCampaigns ? (
                        <FormikField
                            name="owner"
                            category="select"
                            label="Campaign Owner"
                            className="w-full max-w-sm"
                            placeholder="Select owner"
                            options={THIRD_PARTY_CAMPAIGN_OWNERS}
                            allowClear
                            disabled={Boolean(formik.values.id)}
                        />
                    ) : null}
                </div>
                <div className="flex">
                    <FormikField
                        name="externalCampaignId"
                        category="input"
                        label="External Campaign ID"
                        className="w-full max-w-sm"
                    />
                    <Tooltip
                        className="flex ml-3 items-end pb-[14px]"
                        title="Your input value in this field should be unique and cannot be reused for another campaign. It will be propagated in wallet operations as per integration documentation."
                    >
                        <QuestionCircleOutlined />
                    </Tooltip>
                </div>
            </div>

            <Divider />

            <div className="flex flex-col space-y-2">
                <FormikField
                    name="timezone"
                    category="select"
                    label="Time Zone"
                    className="w-full max-w-sm"
                    options={timezoneList}
                />
            </div>

            <div className="flex items-center">
                <FormikField
                    name="start_at"
                    category="datePicker"
                    label="Start at"
                    className="w-full max-w-xs mr-4"
                />
                <FormikField
                    name="end_at"
                    category="datePicker"
                    label="End at"
                    className="w-full max-w-xs mr-4"
                />
            </div>

            <div className="flex items-center">
                <FormikField
                    name="valid_for"
                    category="input"
                    type="number"
                    label="Expiration Time (days)"
                    className="w-full max-w-xs mr-4"
                />
                <FormikField
                    name="start_event"
                    category="select"
                    label="Start Counting From"
                    className="w-full max-w-xs mr-4"
                    disabled={!formik.values.valid_for}
                    options={[
                        { value: 'ASSIGN', label: 'Player Added To The Campaign' },
                        { value: 'ACCEPT', label: 'Player Accepts The Campaign' },
                    ]}
                />
                <FormikField
                    name="allowPostExpirationCompletion"
                    category="checkbox"
                    className="w-full"
                    disabled={!formik.values.valid_for}
                />
            </div>

            <Divider />

            <div className="flex flex-col space-y-2">
                <FormikField
                    name="rulesUrl"
                    category="input"
                    label="Rules URL"
                    className="w-full max-w-sm"
                />
            </div>
        </div>
    );
};

export default ConfigurationTab;
